import { GraphQLID, GraphQLNonNull } from 'graphql'
import {
  attestationReportRequestType,
  AttestationReportRequest
} from '../mutations/generate-attestation-report'

export interface ReportingInfoQueryArgs {
  readonly organizationID: string
  readonly applicationID: string

  readonly filters: AttestationReportRequest
}

export const reportingInfoQueryArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  applicationID: {
    description: 'The unique ID for the application being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  filters: {
    description: 'Options for filtering vulnerabilities and routes',
    type: attestationReportRequestType
  }
}
